export const DEFAULT_DURATION_MS = 60 * 60 * 1000;

/**
 * Combines a date (calendar day) and a time (hours/minutes) into a single Date.
 * If either argument is null, returns null.
 */
export const combineDateAndTime = (date: Date | null, time: Date | null): Date | null => {
  if (date === null || time === null) return null;
  const combined = new Date(date);
  combined.setHours(time.getHours(), time.getMinutes(), 0, 0);
  return combined;
};

/**
 * Converts a local Date (whose hours/minutes were set in the browser's local timezone)
 * to an ISO UTC string as if the user is in the given GMT offset (in hours).
 *
 * Mirrors the formula used in ScheduleVideoMeetingModal: compute the diff between
 * the target timezone and the browser timezone, then shift the date by that diff.
 * This handles the case where the user's selected timezone differs from the machine's.
 */
export const applyTimezoneOffset = (localDate: Date, gmtOffsetHours: number): string => {
  const browserOffsetMin = localDate.getTimezoneOffset();
  const targetOffsetMin = -gmtOffsetHours * 60;
  const diffMs = (targetOffsetMin - browserOffsetMin) * 60 * 1000;
  return new Date(localDate.getTime() + diffMs).toISOString();
};
